import {
  LOGIN_SUCESS,
  LOGOUT,
  LOGIN_ERROR,
  LOGIN_LOADING,
  LOGIN_CLEAR_ERROR,
} from '../actions/types';

const defaultState = {
  authenticated: false,
  authenticating: false,
  error: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOGIN_SUCESS:
      return { ...state, authenticated: true, error: null, authenticating: false };
    case LOGIN_ERROR:
      return { ...state, authenticating: false, error: action.error };
    case LOGIN_CLEAR_ERROR:
      return { ...state, error: null };
    case LOGIN_LOADING:
      return { ...state, authenticating: true, error: null };
    case LOGOUT:
      return { ...state, authenticated: false };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.reducer.js